<script>
  import PageCard from './PageCard.svelte';

  let { pages = [], onTap, onDelete, onReorder } = $props();

  let draggingIndex = $state(null);
</script>

<div class="page-grid">
  {#each pages as page, index (page.id)}
    <PageCard
      {page}
      pageNumber={index + 1}
      isDragging={draggingIndex === index}
      onTap={() => onTap?.(page)}
      onDelete={() => onDelete?.(page.id)}
      onDragStart={() => draggingIndex = index}
      onDragEnd={() => draggingIndex = null}
    />
  {/each}
</div>

<style>
  .page-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
    padding: 16px;
    overflow-y: auto;
    max-height: calc(100vh - 220px);
  }
</style>
